export default __webpack_public_path__ + "static/media/james-cameron.44f79ff9.png";